/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable @typescript-eslint/no-redeclare */
/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Grid, Paper, Switch, Typography } from "@mui/material";
import label from "../../../../components/label";
import { useEffect, useLayoutEffect, useState } from "react";
import Iconify from "../../../../components/iconify";
import {
  GoogleAddressAutoCompleteKey,
  TimeZoneApiKey,
} from "../../../../utils/constant";
import ValidationError from "../../../../components/validation-error-label";
import TexBoxWithLabel from "../../../../components/text-field";
import TimeTable from "../../../../components/time-table";
import { GET, POST } from "../../../../config/https";
import APIS from "../../../../config/api";
import { isEmpty } from "../../../../utils/validator";
import { usePersistentState } from "../../../../contexts/global-context";

import { GetLocalStorage } from "../../../../utils/local-storage";
import { useLocation } from "react-router-dom";
import GooglePlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from "react-google-places-autocomplete";
import axios from "axios";
import FullScreenLoader from "../../../../components/full-screen-loader";
import SeparateDateTime from "../../../../utils/sparate-time-date";
import GlobalDateFormat from "../../../../utils/global-date-format";
import AutoCompleteDropDown from "../../../../components/auto-complete-dropdown";
import toast from "react-hot-toast";
const EventVenueProps = {
  City: "",
  AddressLine1: "",
  VenueName:"",
  Country: "",
  ZipCode: "",
  State: "",
  Timezone: null,
  id: null,
};

const EventVenueSchedule = () => {
  let VenueLocalStorageValue: any = GetLocalStorage("eventVenue");
  const [state, dispatch]: any = usePersistentState();
  const [switchOn, setSwitchOn] = useState(false);
  const [eventVenue, setEventVenue] = useState<any>(EventVenueProps);
  const [googleAddressValue, setGoogleAddressValue] = useState<any>(
    VenueLocalStorageValue?.venue ?? ""
  );
  const [eventSchedule, setEventSchedule] = useState<
    {
      startDate: string;
      startTime: string;
      endTime: string;
      endDate: string;
      id: number;
      IsDisabled: boolean;
    }[]
  >([
    {
      startDate: "",
      endDate: "",
      startTime: "",
      endTime: "",
      id: 0,
      IsDisabled: false,
    },
  ]);
  const [selectedTimeZone, setSelectedTimeZone] = useState<any>("");
  const [timeZoneData, setTimeZoneData] = useState([]);
  const [addManualAddress, setAddManualAddress] = useState(false);
  const [isValidation, setIsValidation] = useState(false);
  const [formErrors, setFormErrors] = useState<Record<string, string>>({});
  const [letLong, setLatLong] = useState<any>({});
  const switchHandler = (event: any) => {
    setSwitchOn(!switchOn);
    setGoogleAddressValue("");
  };
  useLayoutEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);
  useEffect(() => {
    window.history.replaceState({}, document.title);
  }, []);

  useEffect(() => {
    const { City, AddressLine1, Country, ZipCode, State, Timezone } =
      eventVenue;
    if (City || AddressLine1 || Country || ZipCode || State || Timezone) {
      setAddManualAddress(true);
    } else {
      setAddManualAddress(false);
    }
  }, [eventVenue]);

  useEffect(() => {
    getAllTimeZone();
  }, []);

  useEffect(() => {
    if (isValidation) {
      validator();
    }
  }, [eventVenue, eventSchedule, isValidation, googleAddressValue]);
  useEffect(() => {
    if (
      state.WizardKey === 1 &&
      state.AddEventType === "AddEventVenueSchedule"
    ) {
      setIsValidation(true);
      if (!validator()) {
        dispatch({
          AddEventType: "",
        });
        return;
      }
      AddMethod();
    }
  }, [state.WizardKey, state.AddEventType, state.toggleState]);

  useEffect(() => {
    if (selectedTimeZone === "Central Daylight Time") {
      let tempTimeZonData: any = timeZoneData.find(
        (x: any) => x?.timeZoneName === "Central Daylight Time"
      );
      let newData = eventVenue;
      newData.Timezone = tempTimeZonData;
      setEventVenue(newData);
    }
    if (selectedTimeZone === "Central Standard Time") {
      let tempTimeZonData: any = timeZoneData.find(
        (x: any) => x?.timeZoneName === "Central time"
      );
      let newData = eventVenue;
      newData.Timezone = tempTimeZonData;
      setEventVenue(newData);
    }
    if (selectedTimeZone === "Alaska Standard Time") {
      let tempTimeZonData: any = timeZoneData.find(
        (x: any) => x?.timeZoneName === "Alaska time"
      );
      let newData = eventVenue;
      newData.Timezone = tempTimeZonData;
      setEventVenue(newData);
    }
    if (selectedTimeZone === "Alaska Daylight Time") {
      let tempTimeZonData: any = timeZoneData.find(
        (x: any) => x?.timeZoneName === "Alaska Daylight Time"
      );
      let newData = eventVenue;
      newData.Timezone = tempTimeZonData;
      setEventVenue(newData);
    }
    if (selectedTimeZone === "Eastern Standard Time") {
      let tempTimeZonData: any = timeZoneData.find(
        (x: any) => x?.timeZoneName === "Eastern time"
      );
      let newData = eventVenue;
      newData.Timezone = tempTimeZonData;
      setEventVenue(newData);
    }
    if (selectedTimeZone === "Eastern Daylight Time") {
      let tempTimeZonData: any = timeZoneData.find(
        (x: any) => x?.timeZoneName === "Eastern Daylight Time"
      );
      let newData = eventVenue;
      newData.Timezone = tempTimeZonData;
      setEventVenue(newData);
    }
    if (
      selectedTimeZone === "Hawaii-Aleutian Standard Time" ||
      selectedTimeZone === "Hawaii Standard Time"
    ) {
      let tempTimeZonData: any = timeZoneData.find(
        (x: any) => x?.timeZoneName === "Hawaii-Aleutian time"
      );
      let newData = eventVenue;
      newData.Timezone = tempTimeZonData;
      setEventVenue(newData);
    }
    if (
      selectedTimeZone === "Hawaii-Aleutian Daylight Time" ||
      selectedTimeZone === "Hawaii Daylight Time"
    ) {
      let tempTimeZonData: any = timeZoneData.find(
        (x: any) => x?.timeZoneName === "Hawaii-Aleutian Daylight Time"
      );
      let newData = eventVenue;
      newData.Timezone = tempTimeZonData;
      setEventVenue(newData);
    }
    if (selectedTimeZone === "Mountain Standard Time") {
      let tempTimeZonData: any = timeZoneData.find(
        (x: any) => x?.timeZoneName === "Mountain time"
      );
      let newData = eventVenue;
      newData.Timezone = tempTimeZonData;
      setEventVenue(newData);
    }
    if (selectedTimeZone === "Mountain Daylight Time") {
      let tempTimeZonData: any = timeZoneData.find(
        (x: any) => x?.timeZoneName === "Mountain Daylight Time"
      );
      let newData = eventVenue;
      newData.Timezone = tempTimeZonData;
      setEventVenue(newData);
    }
    if (selectedTimeZone == "Pacific Standard Time") {
      let tempTimeZonData: any = timeZoneData.find(
        (x: any) => x?.timeZoneName === "Pacific time"
      );
      let newData = eventVenue;
      newData.Timezone = tempTimeZonData;
      setEventVenue(newData);
    }
    if (selectedTimeZone == "Pacific Daylight Time") {
      let tempTimeZonData: any = timeZoneData.find(
        (x: any) => x?.timeZoneName === "Pacific Daylight Time"
      );
      let newData = eventVenue;
      newData.Timezone = tempTimeZonData;
      setEventVenue(newData);
    }
  }, [selectedTimeZone]);

  useEffect(() => {
    findLonAndLat();
  }, [googleAddressValue]);

  useLayoutEffect(() => {
    setEventVenue(EventVenueProps);
  }, []);

  useEffect(() => {
    let eventVenueModel: any = GetLocalStorage("eventVenue");
    if (eventVenueModel) {
      let newEventCustom = eventVenue;
      newEventCustom.City = eventVenueModel?.city;
      newEventCustom.id = eventVenueModel?.id;
      newEventCustom.State = eventVenueModel?.state;
      newEventCustom.AddressLine1 = eventVenueModel?.address1;
      newEventCustom.ZipCode = eventVenueModel?.zipCode;
      newEventCustom.Country = eventVenueModel?.country;
      newEventCustom.Timezone = eventVenueModel?.timeZone;
      setAddManualAddress(eventVenueModel?.address1?.length > 0 ? true : false);
      setEventVenue(newEventCustom);
      setGoogleAddressValue(eventVenueModel?.venue);
    } else {
      eventVenue.City = "";
      eventVenue.AddressLine1 = "";
      eventVenue.Country = "";
      eventVenue.ZipCode = "";
      eventVenue.State = "";
      eventVenue.Timezone = null;
      eventVenue.id = 0;
    }
    let tempEventSchedule: any = GetLocalStorage("eventSchedule");
    if (tempEventSchedule) {
      let newEventSchedule = tempEventSchedule?.map((x: any) => {
        // let temp = null;
        // if (!x?.timeZone && x?.timeZoneId) {
        //   temp = timeZoneData.find((y: any) => y?.id === x?.timeZoneId);
        // }
        function extractTimeFromDate(dateTimeString: string) {
          const timePart = dateTimeString.split("T")[1];
          return timePart;
        }
        const starttimeOnly = extractTimeFromDate(x?.startDate);
        const endTimeOnly = extractTimeFromDate(x?.endDate);
        return {
          startDate: x.startDate,
          endDate: x?.endDate,
          startTime: starttimeOnly,
          endTime: endTimeOnly,
          id: x?.id,
          IsDisabled: x.isDisabled,
        };
      });

      setEventSchedule(newEventSchedule);
    }
  }, []);

  const AddMethod = async () => {
    try {
      let isSuccess = await AddEventVenue();
      if (isSuccess) {
        let isSuccessSchedule = await AddEventSchedule();
        if (isSuccessSchedule) {
          dispatch({ WizardKey: state.WizardKey + 1, AddEventType: "" });
        }
      }
    } catch (error) {
      // Handle errors
      console.error("Error occurred:", error);
    }
  };
  const googleAddressLine = [googleAddressValue?.label];
  const googleAddress = googleAddressLine.toString();
  const AddEventVenue = async () => {
    setIsValidation(true);
    dispatch({ FullScreenLoader: true });

    let temp: any = localStorage.getItem("eventDetails");
    let eventId = JSON.parse(temp);
    if (!eventId) return;

    let param = {
      eventId: eventId?.id,
      id: eventVenue?.id,
      VenueName:eventVenue.VenueName,
      venue: googleAddress,
      latitude: letLong?.lat,
      longitude: letLong?.lng,
      address1: eventVenue?.AddressLine1,
      city: eventVenue.City,
      country: eventVenue?.Country,
      zipCode: eventVenue?.ZipCode,
      state: eventVenue?.State,
      isVirtualEvent: switchOn,
      timeZoneId: eventVenue?.Timezone?.id,
    };
    try {
      const res: any = await POST(APIS.Add_Event_Venue, param);
      if (res?.isSuccess) {
        localStorage.setItem("eventVenue", JSON.stringify(res?.result));

        if (state.FilledSteps[state.FilledSteps.length - 2] < 5) {
          const updatedSteps = state.FilledSteps.includes(2)
            ? [...state.FilledSteps]
            : [...state.FilledSteps, 2];
          dispatch({ FilledSteps: updatedSteps });
        }
        return true;
      } else {
        return false;
      }
    } catch (error) {
      console.error(error);
    } finally {
      dispatch({ FullScreenLoader: false });
    }
  };

  const AddEventSchedule = async () => {
    dispatch({ FullScreenLoader: true });
    let eventDetails: any = localStorage.getItem("eventDetails");
    eventDetails = JSON.parse(eventDetails);
    let eventScheduleParam = await Promise.all(
      eventSchedule.map(async (x: any) => {
        const endDate = await GlobalDateFormat(x?.endDate, x?.endTime);
        const startDate = await GlobalDateFormat(x?.startDate, x?.startTime);
        return {
          endDate: endDate,
          startDate: startDate,
          eventId: eventDetails?.id,
          id: x?.id,
          isDisabled: x?.IsDisabled,
        };
      })
    );

    if (!eventDetails) return;
    let param = {
      eventId: eventDetails?.id,
      eventSchedule: eventScheduleParam,
    };
    try {
      const res: any = await POST(APIS.ADD_EVENT_SCHEDULE, param);
      if (res?.isSuccess) {
        localStorage.setItem("eventSchedule", JSON.stringify(res?.result));
        if (state.FilledSteps[state.FilledSteps.length - 2] < 5) {
          const updatedSteps = state.FilledSteps.includes(2)
            ? [...state.FilledSteps]
            : [...state.FilledSteps, 2];
          dispatch({ FilledSteps: updatedSteps });
        }
        return true;
      } else {
        return false;
      }
    } catch (error) {
      console.error(error);
    } finally {
      dispatch({ FullScreenLoader: false });
    }
  };

  const findLonAndLat = async () => {
    const address = googleAddressValue?.label;
    try {
      if (address) {
        await geocodeByAddress(address)
          .then((results) => getLatLng(results[0]))
          .then(async ({ lat, lng }) => {
            let newData = {
              lat,
              lng,
            };
            setLatLong(newData);
            let timezone = await getTimeZone(lat, lng);
            setSelectedTimeZone(timezone);
          });
        const results = await geocodeByAddress(address);
        const placeDetails = results[0];
        const city =
          placeDetails?.address_components?.find((component: any) =>
            component?.types.includes("locality")
          )?.long_name || "";
        const state =
          placeDetails?.address_components?.find((component: any) =>
            component?.types.includes("administrative_area_level_1")
          )?.long_name || "";
        const country =
          placeDetails?.address_components?.find((component: any) =>
            component?.types.includes("country")
          )?.short_name || "";

        const postalCode =
          placeDetails?.address_components?.find((component: any) =>
            component?.types.includes("postal_code")
          )?.long_name || "";
        let addressModal = { ...eventVenue };
        addressModal.City = city;
        const AddressLine =
          (await googleAddressValue?.value?.structured_formatting?.main_text) ??
          "";

        addressModal.AddressLine1 = AddressLine;
        addressModal.Country = country;
        addressModal.State = state;
        addressModal.ZipCode = postalCode;
        addressModal.VenueName = googleAddressValue?.value?.structured_formatting?.main_text;
        const remainingComponents = placeDetails?.address_components
          ?.filter(
            (component: any) =>
              ![
                "locality",
                "administrative_area_level_1",
                "country",
                "postal_code",
              ].some((type) => component?.types?.includes(type))
          )
          .map((component: any) => component?.long_name)
          .join(", ");
        addressModal.AddressLine1 += remainingComponents
          ? `, ${remainingComponents}`
          : "";
        setEventVenue(addressModal);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      return null;
    }
  };

  const getAllTimeZone = async () => {
    let param: any = {
      pageSize: 50,
    };
    await GET(APIS.GET_ALL_TIME_ZONE, param)
      .then((res: any) => {
        if (res?.isSuccess) {
          setTimeZoneData(res?.result);
        }
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  const getTimeZone = async (lat: any, lon: any) => {
    try {
      const timestamp = Math.floor(Date.now() / 1000);

      const response = await axios.get(
        `${APIS.GET_LAT_LONG_TO_LOCATION}=${lat},${lon}&timestamp=${timestamp}&key=${TimeZoneApiKey}`
      );
      if (!response.data || response.data.status !== "OK") {
        throw new Error("Failed to fetch time zone data");
      }
      return response.data.timeZoneName;
    } catch (error) {
      console.error("Error fetching time zone data:", error);
      return "Unknown";
    }
  };

  const handleChangeInputTime = async (
    index: number,
    event: any,
    timezone: string,
    name?: string
  ) => {
    const values: any = [...eventSchedule];
    if (timezone === "timezone") {
      values[index].timezone = event;
      setEventSchedule(values);
      return;
    }
    let date = event?.$d?.toLocaleString();
    let time = event?.$d?.toLocaleString();
    if (name === "startDate" || name === "endDate") {
      var temp = await SeparateDateTime(event?.$d);
      date = temp?.date;
    }
    if (name === "startTime" || name === "endTime") {
      var temp = await SeparateDateTime(event?.$d);
      time = temp?.time;
    }
    switch (name) {
      case "startDate":
        values[index].startDate = date;
        break;
      case "endDate":
        values[index].endDate = date;
        break;
      case "startTime":
        values[index].startTime = time;
        break;
      case "endTime":
        values[index].endTime = time;
        break;
    }
    setEventSchedule(values);
  };

  const handleRemoveFieldsTime = (index: number) => {
    let values = [...eventSchedule];

    if (index >= 0 && index < values.length) {
      values.splice(index, 1);
      setEventSchedule(values);
    } else {
      console.log("Invalid index");
    }
  };

  const handleAddFieldsTime = () => {
    setEventSchedule([
      ...eventSchedule,
      {
        startDate: "",
        endDate: "",
        id: 0,
        IsDisabled: false,
        startTime: "",
        endTime: "",
      },
    ]);
  };

  const onChangeFormDataEventVenue = async (key: string, e: any) => {
    let newData = { ...eventVenue };
    switch (key) {
      case "AddressLine1":
        newData.AddressLine1 = e.target.value;
        break;
      case "ZipCode":
        newData.ZipCode = e.target.value;
        break;
      case "City":
        newData.City = e.target.value;
        break;
      case "State":
        newData.State = e.target.value;
        break;
      case "Country":
        newData.Country = e.target.value;
        break;
      case "Timezone":
        newData.Timezone = e;
        break;
    }
    setEventVenue(newData);
  };

  const validator = () => {
    const errors: Record<string, string> = {};

    if (
      !addManualAddress &&
      (!googleAddressValue || googleAddressValue.length === 0)
    ) {
      errors.googleAddressValue = "Please Select Venue";
    }

    if (googleAddressValue.length < 1 || addManualAddress) {
      if (isEmpty(eventVenue.AddressLine1 ?? "")) {
        errors.AddressLine1 = "AddressLine1 is required";
      }
      if (isEmpty(eventVenue.State ?? "")) {
        errors.State = "State is required";
      }
      if (isEmpty(eventVenue.Country ?? "")) {
        errors.Country = "Country is required";
      }
      if (isEmpty(eventVenue.City ?? "")) {
        errors.City = "City is required";
      }
      if (!eventVenue.Timezone || typeof eventVenue.Timezone !== "object") {
        errors.Timezone = "Timezone is required";
      }
    }

    eventSchedule?.forEach((schedule, index: number) => {
      const startDateTime = GlobalDateFormat(
        schedule.startDate,
        schedule.startTime
      );
      const endDateTime = GlobalDateFormat(schedule.endDate, schedule.endTime);
      if (isEmpty(schedule.startDate)) {
        errors[`startDate-${index}`] = "Start Date is required";
      }
      if (isEmpty(schedule.endDate)) {
        errors[`endDate-${index}`] = "End Date is required";
      }
      if (isEmpty(schedule.startTime)) {
        errors[`startTime-${index}`] = "Start Time is required";
      }
      if (isEmpty(schedule.endTime)) {
        errors[`endTime-${index}`] = "End Time is required";
      }
      if (endDateTime && startDateTime && startDateTime >= endDateTime) {
        errors[`endDate-${index}`] =
          "End Date should be greater then Start Date";
      }
    });

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  return (
    <div>
      <Paper
        elevation={3}
        style={{ padding: "16px", width: "100%", marginTop: 70 }}
      >
        <FullScreenLoader open={state.FullScreenLoader} />
        <Grid container>
          <Grid item xs={12} sm={12} md={6}>
            <Typography sx={{ width: "100%", fontWeight: "600" }}>
              Event Venue
            </Typography>
            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography
                sx={{
                  width: "100%",
                  fontWeight: "300",
                  justifyContent: "flex-start!important",
                }}
              >
                Online/Virtual Events? (No/Yes)
              </Typography>
              <Typography>
                <Switch
                  {...label}
                  sx={{
                    display: "flex",
                  }}
                  checked={switchOn}
                  onChange={switchHandler}
                />
              </Typography>
            </div>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          {!switchOn && (
            <div style={{ marginTop: 10, height: "100%", flex: 1 }}>
              <Box sx={{ height: "100%" }}>
                <div>
                  <Typography
                    sx={{
                      width: "100%",
                      fontWeight: "600",
                      marginBottom: 0.5,
                      display: "flex",
                      justifyContent: "start",
                      alignItems: "center",
                    }}
                  >
                    Search Address
                    <Iconify icon={"logos:google-maps"} sx={{ mr: 2 }} />
                  </Typography>
                  <div style={{ marginTop: 10, height: "100%", flex: 1 }}>
                    <GooglePlacesAutocomplete
                      apiKey={GoogleAddressAutoCompleteKey}
                      selectProps={{
                        value: googleAddressValue ?? "",
                        defaultInputValue: googleAddressValue ?? "",
                        isClearable: true,
                        onChange: setGoogleAddressValue,
                        styles: {
                          option: (provided) => ({
                            ...provided,
                          }),
                          container: (provided) => ({
                            ...provided,
                            zIndex: 999,
                            width: "100%",
                          }),
                        },
                      }}
                    />
                  </div>
                </div>
                <ValidationError formErrors={formErrors.googleAddressValue} />
              </Box>
            </div>
          )}
        </Grid>
        {!switchOn ? (
          <div style={{ width: "100%", marginTop: 18 }}>
            <a
              onClick={() => setAddManualAddress(!addManualAddress)}
              style={{
                borderBottom: "solid 1px blue",
                color: "blue",
                cursor: "pointer",
              }}
            >
              Add address manually
            </a>
          </div>
        ) : null}
        {!switchOn && addManualAddress ? (
          <div style={{ marginTop: 2, width: "100%" }}>
            <Grid container xs={12} sm={12} md={12} spacing={1}>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <TexBoxWithLabel
                  size="small"
                  placeholder="Address Line1"
                  fullWidth={true}
                  multiline={true}
                  value={eventVenue?.AddressLine1}
                  label="Address Line1"
                  style={{ ...Styles.labelTextBoxMg, marginTop: 20 }}
                  onChange={(event) => {
                    onChangeFormDataEventVenue("AddressLine1", event);
                  }}
                />
                <ValidationError formErrors={formErrors.AddressLine1} />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <TexBoxWithLabel
                  size="small"
                  placeholder="City"
                  fullWidth={true}
                  multiline={true}
                  value={eventVenue?.City}
                  label="City"
                  style={{ ...Styles.labelTextBoxMg, marginTop: 20 }}
                  onChange={(event) => {
                    onChangeFormDataEventVenue("City", event);
                  }}
                />
                <ValidationError formErrors={formErrors.City} />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <TexBoxWithLabel
                  size="small"
                  placeholder="State"
                  fullWidth={true}
                  multiline={true}
                  value={eventVenue?.State}
                  label="State"
                  style={{ ...Styles.labelTextBoxMg, marginTop: 20 }}
                  onChange={(event) => {
                    onChangeFormDataEventVenue("State", event);
                  }}
                />
                <ValidationError formErrors={formErrors.State} />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <TexBoxWithLabel
                  size="small"
                  placeholder="Country"
                  fullWidth={true}
                  multiline={true}
                  value={eventVenue?.Country}
                  label="Country"
                  style={{ ...Styles.labelTextBoxMg, marginTop: 20 }}
                  onChange={(event: any) => {
                    onChangeFormDataEventVenue("Country", event);
                  }}
                />
                <ValidationError formErrors={formErrors.Country} />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <TexBoxWithLabel
                  size="small"
                  placeholder="Zip Code"
                  fullWidth={true}
                  value={eventVenue?.ZipCode}
                  label="Zip Code"
                  style={{ ...Styles.labelTextBoxMg, marginTop: 20 }}
                  onChange={(event: any) => {
                    onChangeFormDataEventVenue("ZipCode", event);
                  }}
                />
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                style={{ marginTop: 20 }}
              >
                <AutoCompleteDropDown
                  fullWidth={true}
                  data={timeZoneData}
                  onChange={(newValue) => {
                    onChangeFormDataEventVenue("Timezone", newValue);
                  }}
                  label={"timeZoneName"}
                  value={eventVenue?.Timezone}
                  dropDownDisplayLabel={"Time Zone"}
                />
                <ValidationError formErrors={formErrors.Timezone} />
              </Grid>
            </Grid>
          </div>
        ) : null}
      </Paper>
      <Paper
        elevation={3}
        style={{ padding: "16px", width: "100%", marginTop: 25 }}
      >
        <Typography sx={{ width: "100%", fontWeight: "600", marginBottom: 2 }}>
          Event Schedule
        </Typography>
        <TimeTable
          TimeZoneData={timeZoneData}
          onChangeDateTimeTable={(newValue) => {
            setEventSchedule(newValue);
          }}
          validDateError={formErrors}
          data={eventSchedule}
          handleChangeInput={(
            index: number,
            event: any,
            timezone?: string,
            name?: string
          ) =>
            handleChangeInputTime(index, event, timezone ? timezone : "", name)
          }
          handleRemoveFields={(index: number) => handleRemoveFieldsTime(index)}
          handleAddFields={() => {
            handleAddFieldsTime();
          }}
        />
      </Paper>
    </div>
  );
};
export default EventVenueSchedule;

const Styles = {
  labelTextBoxMg: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
  },
};
